import { BaseAPI } from "../base/service";
import { CourseType } from "../enums";

export class ExamResolutionAPI extends BaseAPI {
    private year: number = new Date().getFullYear();

    public getList(type: CourseType): Promise<any[]> {
        return this.api.get(`/${type}/${this.year}/exam-resolution/`);
    }
}